<template>
    <div class="initiate-wrap">
        <van-nav-bar title="发起合同签署" left-text="返回" right-text="查看合同信息" left-arrow @click-left="onClickLeft"
            @click-right="onClickRight" />
        <van-form ref="form" :model="approve" class="form">
            <!-- 签署标题、客户名称、客户电话、签署方式、签署文件 -->
            <!-- 线下签署或多合同签署时必须上传文件 -->
            <van-field v-model="approve.signTitle" name="signTitle" label="签署标题" placeholder="请输入签署标题"
                :rules="[{ required: true, message: '请输入签署标题', trigger: 'change' }]" required />
            <van-field v-model="approve.contactName" name="contactName" label="客户名称" placeholder="请输入客户名称"
                :rules="[{ required: true, message: '客户名称不能为空', trigger: 'change' }]" required />
            <van-field v-model="approve.contactPhone" name="contactPhone" label="客户电话" placeholder="请输入客户电话"
                :rules="[{ required: true, message: '客户电话不能为空', trigger: 'change' }]" required />
            <van-field name="onlineSignFlag" label="签署方式">
                <template #input>
                    <van-radio-group v-model="approve.onlineSignFlag" direction="horizontal">
                        <van-radio :name="true">线上</van-radio>
                        <van-radio :name="false">线下</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-if="approve.onlineSignFlag === false || (contract && contract.length > 1)" center label="签署文件"
                required placeholder="请上传签署文件" name="fileName" v-model="fileName" readonly
                :rules="[{ required: true, message: '请上传签署文件', trigger: 'change' }]">
                <template #button>
                    <input ref="fileInput" type="file" @change="onFileChange" style="display:none" />
                    <van-button size="small" type="primary" @click="openFileChooser">选择文件</van-button>
                </template>
            </van-field>
            <div class="actions">
                <van-button round block type="info" :loading="loading" @click="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { contractSignApply } from "@/api/dilivery/sign";
import { getDataInLocalStorage } from "@/utils/localStorage";
export default {
    name: "InitiateSignContract",
    props: {
    },
    data() {
        return {
            approve: {
                signTitle: '',
                file: null,
                onlineSignFlag: true,
                contractIds: [],
                contactName: '',
                contactPhone: ''
            },
            fileName: '',
            loading: false,
            activeNames:''
        };
    },
    computed: {
        contract() {
            return JSON.parse(getDataInLocalStorage('mSignData'));
        }
    },
    created() {
        if (this.contract && this.contract.length) {
            this.approve.contractIds = this.contract.map(x => x.id);
            this.approve.signTitle = this.contract[0].contractName || '';
            this.approve.contactName = this.contract[0].customerContacts?.contactName || '';
            this.approve.contactPhone = this.contract[0].customerContacts?.phone || '';
        }
    },
    methods: {
        onClickLeft() {
            this.$router.back();
        },
        openFileChooser() {
            this.$refs.fileInput.click();
        },
        onClickRight() {
            this.$router.push('/showSignInfo')
        },
        onFileChange(e) {
            const f = e.target.files && e.target.files[0];
            if (f) {
                this.approve.file = f;
                this.fileName = f.name;
            }
        },
        close() {
            this.reset();
        },
        reset() {
            this.approve.file = null;
            this.fileName = '';
            this.loading = false;
        },
        submit() {
            // 简单校验 Vant 表单
            this.$refs.form.validate().then(async valid => {
                // 若线下或多合同时必须上传文件
                if ((this.approve.onlineSignFlag === false || (this.contract && this.contract.length > 1)) && !this.approve.file) {
                    this.$toast && this.$toast.fail('请上传签署文件');
                    return;
                }
                this.loading = true;
                try {
                    const formData = new FormData();
                    if (this.approve.onlineSignFlag === false || this.contract.length > 1) {
                        formData.append('file', this.approve.file);
                    }
                    const infoObj = Object.keys(this.approve).reduce((acc, key) => {
                        if (key !== 'file') acc[key] = this.approve[key];
                        return acc;
                    }, {});
                    const blob = new Blob([JSON.stringify(infoObj)], { type: 'application/json' });
                    formData.append('info', blob);

                    const res = await contractSignApply(formData);
                    this.loading = false;
                    if (res && res.code === 200) {
                        this.$toast && this.$toast.success('合同签署发起成功');
                        this.reset();
                        this.$router.push('/signRecord');
                    } else {
                        this.$toast && this.$toast.fail((res && res.message) || '发起失败');
                    }
                } catch (e) {
                    this.loading = false;
                    console.error(e);
                    this.$toast && this.$toast.fail('提交失败');
                }
            }).catch(() => {
                this.$toast && this.$toast.fail('信息填写不完整，请检查');
                this.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.initiate-wrap {
    position: fixed;
    inset: 0;
    background: #f7f8fa;
    display: flex;
    flex-direction: column;
    height: 100vh;
}


.form {
    padding: 16px;
    overflow-y: auto;
    flex: 1;
    -webkit-overflow-scrolling: touch;
}
.van-nav-bar {
    background: #fff;
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
}
.van-field {
    margin-bottom: 8px;
    background: #fff;
    border-radius: 8px;
}
.row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 0;
}
.van-button {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
}

.actions {
    padding: 16px;
    padding-bottom: calc(16px + constant(safe-area-inset-bottom));
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}
</style>